import { render, staticRenderFns } from "./VehicleAttribute.vue?vue&type=template&id=2b309ff2&"
import script from "./VehicleAttribute.vue?vue&type=script&lang=js&"
export * from "./VehicleAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports